import { render } from "./AppMaintenanceBody.vue?vue&type=template&id=ecc3dd44"
import script from "./AppMaintenanceBody.vue?vue&type=script&lang=js"
export * from "./AppMaintenanceBody.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__